import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const dayListStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};

/**
 * One weekday.
 *
 * Stacked on a phone and in a row from `sm` up. The row keeps its items top-aligned rather
 * than centred, so a time field showing its error text does not shove the day's name and its
 * switch downwards while the neighbouring rows stay put.
 */
export const dayRowStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'stretch', sm: 'flex-start' },
    gap: { xs: 1, sm: 2 },
};

/**
 * The day's name, on a fixed width so the seven switches line up in a column rather than
 * stepping in and out with the length of the word.
 */
export const dayLabelStyles: SxProps<Theme> = {
    fontWeight: 600,
    minWidth: { sm: 120 },
    // Matches the switch's own height on a fine pointer, so the name sits on its line.
    pt: { sm: 1 },
};

/**
 * The switch, also fixed so the time fields start at the same x on every row. Wide enough for
 * the longer of the two labels -- "Inchis" is shorter than "Deschis", and a width that fits
 * only the current one would shuffle the fields sideways as a day is toggled.
 */
export const dayToggleStyles: SxProps<Theme> = {
    minWidth: { sm: 140 },
    mr: 0,
};

export const dayHoursStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: 1, sm: 2 },
};

/**
 * A time field, capped rather than full width.
 *
 * A time input is five characters wide whatever the container is, and stretching it across a
 * desktop card makes it read as a text field somebody forgot to fill in.
 */
export const timeFieldStyles: SxProps<Theme> = {
    width: { xs: '100%', sm: 160 },
};
